import type { RefObject } from "react";
import styles from "../css/scanner.module.scss";

interface Props {
  videoRef: RefObject<HTMLVideoElement | null>;
}

const CameraView = ({ videoRef }: Props) => {
  return (
    <video
      aria-label="Barcode scanner camera preview"
      ref={videoRef}
      autoPlay
      muted
      playsInline
      className={styles["clinical-camera-video"]}
    />
  );
};

export default CameraView;